import styled from "styled-components";

export const Container = styled.div`
  margin: ${({ fullScreen }) => (fullScreen ? "20" : "0")}px !important;
  height: 100%;
  width: 100%;
`;
